import {nextTick} from "vue"

export default (component: any) => {
    nextTick(() => {
        if (component.focus) {
            component.focus()
        }
    })
}
